/**
 * Phosphor icon helpers - the raw SVGs are imported as strings (vite `?raw`)
 * and inlined so `currentColor` tints them via CSS.
 */

import cursorSvg from '@phosphor-icons/core/assets/regular/cursor.svg?raw';
import caretDownSvg from '@phosphor-icons/core/assets/regular/caret-down.svg?raw';
import caretRightSvg from '@phosphor-icons/core/assets/regular/caret-right.svg?raw';
import paintBrushSvg from '@phosphor-icons/core/assets/regular/paint-brush.svg?raw';
import officeChairSvg from '@phosphor-icons/core/assets/regular/office-chair.svg?raw';
import polygonSvg from '@phosphor-icons/core/assets/regular/polygon.svg?raw';
import penNibSvg from '@phosphor-icons/core/assets/regular/pen-nib.svg?raw';
import bezierCurveSvg from '@phosphor-icons/core/assets/regular/bezier-curve.svg?raw';
import rulerSvg from '@phosphor-icons/core/assets/regular/ruler.svg?raw';
import arrowsOutSvg from '@phosphor-icons/core/assets/regular/arrows-out.svg?raw';
import arrowUUpLeftSvg from '@phosphor-icons/core/assets/regular/arrow-u-up-left.svg?raw';
import trashSvg from '@phosphor-icons/core/assets/regular/trash.svg?raw';
import broomSvg from '@phosphor-icons/core/assets/regular/broom.svg?raw';
import printerSvg from '@phosphor-icons/core/assets/regular/printer.svg?raw';
import checkSvg from '@phosphor-icons/core/assets/regular/check.svg?raw';
import arrowsOutCardinalSvg from '@phosphor-icons/core/assets/regular/arrows-out-cardinal.svg?raw';
import arrowsClockwiseSvg from '@phosphor-icons/core/assets/regular/arrows-clockwise.svg?raw';
import magnifyingGlassPlusSvg from '@phosphor-icons/core/assets/regular/magnifying-glass-plus.svg?raw';
import playSvg from '@phosphor-icons/core/assets/regular/play.svg?raw';
import pauseSvg from '@phosphor-icons/core/assets/regular/pause.svg?raw';
import arrowCounterClockwiseSvg from '@phosphor-icons/core/assets/regular/arrow-counter-clockwise.svg?raw';
import personSvg from '@phosphor-icons/core/assets/regular/person.svg?raw';
import personArmsSpreadSvg from '@phosphor-icons/core/assets/regular/person-arms-spread.svg?raw';
import plusSvg from '@phosphor-icons/core/assets/regular/plus.svg?raw';
import minusSvg from '@phosphor-icons/core/assets/regular/minus.svg?raw';
import flipHorizontalSvg from '@phosphor-icons/core/assets/regular/flip-horizontal.svg?raw';
import selectionAllSvg from '@phosphor-icons/core/assets/regular/selection-all.svg?raw';
import xSvg from '@phosphor-icons/core/assets/regular/x.svg?raw';
import pencilSimpleSvg from '@phosphor-icons/core/assets/regular/pencil-simple.svg?raw';
import squareSvg from '@phosphor-icons/core/assets/regular/square.svg?raw';
import squareSplitHorizontalSvg from '@phosphor-icons/core/assets/regular/square-split-horizontal.svg?raw';
import squareHalfSvg from '@phosphor-icons/core/assets/regular/square-half.svg?raw';
import cubeSvg from '@phosphor-icons/core/assets/regular/cube.svg?raw';
import handSvg from '@phosphor-icons/core/assets/regular/hand.svg?raw';
import caretLeftSvg from '@phosphor-icons/core/assets/regular/caret-left.svg?raw';
import listSvg from '@phosphor-icons/core/assets/regular/list.svg?raw';
import floppyDiskSvg from '@phosphor-icons/core/assets/regular/floppy-disk.svg?raw';
import folderOpenSvg from '@phosphor-icons/core/assets/regular/folder-open.svg?raw';
import downloadSimpleSvg from '@phosphor-icons/core/assets/regular/download-simple.svg?raw';
import uploadSimpleSvg from '@phosphor-icons/core/assets/regular/upload-simple.svg?raw';
import filePlusSvg from '@phosphor-icons/core/assets/regular/file-plus.svg?raw';
import signOutSvg from '@phosphor-icons/core/assets/regular/sign-out.svg?raw';
import userCircleSvg from '@phosphor-icons/core/assets/regular/user-circle.svg?raw';
import linkSimpleSvg from '@phosphor-icons/core/assets/regular/link-simple.svg?raw';
import copySimpleSvg from '@phosphor-icons/core/assets/regular/copy-simple.svg?raw';
import paperPlaneTiltSvg from '@phosphor-icons/core/assets/regular/paper-plane-tilt.svg?raw';
import booksSvg from '@phosphor-icons/core/assets/regular/books.svg?raw';
import globeSvg from '@phosphor-icons/core/assets/regular/globe.svg?raw';

export const ICONS = {
    cursor: cursorSvg,
    hand: handSvg,
    caretLeft: caretLeftSvg,
    caretDown: caretDownSvg,
    caretRight: caretRightSvg,
    paintBrush: paintBrushSvg,
    officeChair: officeChairSvg,
    polygon: polygonSvg,
    penNib: penNibSvg,
    bezierCurve: bezierCurveSvg,
    ruler: rulerSvg,
    arrowsOut: arrowsOutSvg,
    arrowUUpLeft: arrowUUpLeftSvg,
    trash: trashSvg,
    broom: broomSvg,
    printer: printerSvg,
    check: checkSvg,
    arrowsOutCardinal: arrowsOutCardinalSvg,
    arrowsClockwise: arrowsClockwiseSvg,
    magnifyingGlassPlus: magnifyingGlassPlusSvg,
    play: playSvg,
    pause: pauseSvg,
    arrowCounterClockwise: arrowCounterClockwiseSvg,
    person: personSvg,
    personArmsSpread: personArmsSpreadSvg,
    plus: plusSvg,
    minus: minusSvg,
    flipHorizontal: flipHorizontalSvg,
    selectionAll: selectionAllSvg,
    x: xSvg,
    pencilSimple: pencilSimpleSvg,
    square: squareSvg,
    squareSplitHorizontal: squareSplitHorizontalSvg,
    squareHalf: squareHalfSvg,
    cube: cubeSvg,
    list: listSvg,
    floppyDisk: floppyDiskSvg,
    folderOpen: folderOpenSvg,
    downloadSimple: downloadSimpleSvg,
    uploadSimple: uploadSimpleSvg,
    filePlus: filePlusSvg,
    signOut: signOutSvg,
    userCircle: userCircleSvg,
    linkSimple: linkSimpleSvg,
    copySimple: copySimpleSvg,
    paperPlaneTilt: paperPlaneTiltSvg,
    books: booksSvg,
    globe: globeSvg
};

/**
 * Build an inline SVG element from a raw Phosphor SVG string.
 * @param {string} raw - Raw SVG markup
 * @param {number} size - Rendered width/height in px
 * @returns {SVGElement}
 */
export function phIcon(raw, size = 20) {
    const holder = document.createElement('span');
    holder.innerHTML = raw;
    const svg = holder.firstElementChild;
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('fill', 'currentColor');
    svg.style.display = 'block';
    svg.style.flexShrink = '0';
    return svg;
}
